import React from 'react';
import PropTypes from 'prop-types';

import { useId } from '../../hooks';

export default function InputError({ children, id, ...rest }) {
    const computedId = useId(id);

    return (
        <div
            id={`${computedId}-error`}
            className="sarsa-field-error-message"
            aria-live="assertive"
            {...rest}
        >
            {children && (
                <>
                    <span className="req" aria-hidden="true">
                        *
                    </span>
                    {children}
                </>
            )}
        </div>
    );
}

InputError.propTypes = {
    children: PropTypes.node,
    id: PropTypes.string,
};
